import { Injectable } from '@angular/core';
import { Mutation, gql } from 'apollo-angular';
import { UpdateNegotiationInput } from '../components/negotiations/negotiations.model';

@Injectable({
  providedIn: 'root'
})
export class CreateNegotiationCounterService extends Mutation<UpdateNegotiationInput> {

  document = gql`
    mutation AddNegotiationCounter($id: String!, $input: UpdateNegotiationInput!) {
      addNegotiationCounter(id: $id, updateNegotiationInput: $input) {
          _id
          createdAt
          updatedAt
          lot_id
          status
      }
    }
  `
}
